module.exports = __webpack_public_path__ + "static/admatic-4d922b81f4dc1c5dd377f4326b1dc0f2.png";